import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import { colors } from 'style/config';
import {
    Flex, Text, Link, Divider, Icon
} from 'components/ui';
import ScrollAnchor from 'components/ScrollAnchor/ScrollAnchor';

const SectionInfo = ({
    sectionInfo, icon, isCollapsed, isNewUserFlow, localization, sectionIcon
}) => {
    const {
        sectionNumber,
        title,
        subTitle,
        isChangePermitted,
        onChangeClick,
        hasDivider,
        renderErrorView,
        sectionLevelError,
        coustomChangeLabel = null,
        sectionName
    } = sectionInfo;
    const hasSectionError = sectionLevelError?.length > 0 || (typeof sectionLevelError === 'boolean' && sectionLevelError) || renderErrorView;

    const renderTitle = () => {
        // SHP-4190: Handle React elements (like Icon) as sectionNumber
        if (sectionNumber && title) {
            // If sectionNumber is a React element (object), render it separately
            if (typeof sectionNumber === 'object' && React.isValidElement(sectionNumber)) {
                return (
                    <>
                        {sectionNumber} {title}
                    </>
                );
            }

            // Otherwise, treat it as a string/number
            return `${sectionNumber}. ${title}`;
        } else {
            return title;
        }
    };

    return (
        <>
            <ScrollAnchor
                id={sectionName}
                hasOffset={false}
            />
            <Flex
                flexDirection='column'
                justifyContent='space-between'
                alignItems='flex-start'
                paddingX={[4, 4, 5]}
                paddingTop={4}
            >
                <Flex
                    width='100%'
                    flexDirection='row'
                    justifyContent='space-between'
                    alignItems='flex-start'
                >
                    {title?.length > 0 && (
                        <Flex gap={2}>
                            {hasSectionError && (
                                <Icon
                                    name='alert'
                                    size={[20, 24]}
                                    color='error'
                                />
                            )}
                            <Text
                                is='h2'
                                fontSize={['md', 'md', 'lg']}
                                fontWeight='bold'
                                children={renderTitle()}
                                lineHeight={'tight'}
                            />
                            {icon && icon}
                        </Flex>
                    )}
                    {isChangePermitted && !isCollapsed && !isNewUserFlow && (
                        <Link
                            color='blue'
                            lineHeight={'tight'}
                            children={coustomChangeLabel || localization.change}
                            onClick={() => onChangeClick(true, true)}
                            aria-label={`${localization.change} ${title}`}
                        />
                    )}
                    {!isChangePermitted && sectionIcon && sectionIcon}
                </Flex>
                {subTitle?.length > 0 && (
                    <Text
                        is='p'
                        color={colors.gray}
                        marginTop={1}
                        fontSize={['sm', 'sm', 'base']}
                        lineHeight={['tight', 'tight', 'base']}
                        children={subTitle}
                    />
                )}
            </Flex>
            {hasDivider && !isCollapsed && (
                <Divider
                    marginTop={[3, 3, subTitle ? 2 : 4]}
                    color={colors.lightGray}
                />
            )}
        </>
    );
};

export default wrapFunctionalComponent(SectionInfo, 'SectionInfo');
